// extracted by mini-css-extract-plugin
export default {"Blink":"DotDotDot_Blink__jZ86F","blink":"DotDotDot_blink__Wcz+G"};